import ace from "ace-builds"
import "ace-builds/src-noconflict/ext-language_tools"

// Custom Turtle completer
const turtleCompleter = {
  getCompletions: (
    _editor: any,
    _session: any,
    _pos: { row: number; column: number },
    prefix: string,
    callback: (error: any, completions: any[]) => void
  ) => {
    const keywords = [
      // Directives
      { value: '@prefix', meta: 'directive', score: 1000 },
      { value: '@base', meta: 'directive', score: 1000 },
      { value: 'PREFIX', meta: 'directive', score: 1000 },
      { value: 'BASE', meta: 'directive', score: 1000 },
      // Keywords
      { value: 'a', meta: 'keyword (rdf:type)', score: 900 },
      { value: 'true', meta: 'boolean', score: 800 },
      { value: 'false', meta: 'boolean', score: 800 },
      // Common prefixes
      { value: 'rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>', meta: 'prefix', score: 700 },
      { value: 'rdfs: <http://www.w3.org/2000/01/rdf-schema#>', meta: 'prefix', score: 700 },
      { value: 'xsd: <http://www.w3.org/2001/XMLSchema#>', meta: 'prefix', score: 700 },
      { value: 'owl: <http://www.w3.org/2002/07/owl#>', meta: 'prefix', score: 700 },
      { value: 'sh: <http://www.w3.org/ns/shacl#>', meta: 'prefix', score: 700 },
      { value: 'skos: <http://www.w3.org/2004/02/skos/core#>', meta: 'prefix', score: 700 },
      { value: 'dcterms: <http://purl.org/dc/terms/>', meta: 'prefix', score: 700 },
      { value: 'foaf: <http://xmlns.com/foaf/0.1/>', meta: 'prefix', score: 700 },
      // SHACL properties
      { value: 'sh:NodeShape', meta: 'shacl class', score: 600 },
      { value: 'sh:PropertyShape', meta: 'shacl class', score: 600 },
      { value: 'sh:targetClass', meta: 'shacl property', score: 600 },
      { value: 'sh:targetNode', meta: 'shacl property', score: 600 },
      { value: 'sh:property', meta: 'shacl property', score: 600 },
      { value: 'sh:path', meta: 'shacl property', score: 600 },
      { value: 'sh:name', meta: 'shacl property', score: 600 },
      { value: 'sh:description', meta: 'shacl property', score: 600 },
      { value: 'sh:datatype', meta: 'shacl property', score: 600 },
      { value: 'sh:minCount', meta: 'shacl property', score: 600 },
      { value: 'sh:maxCount', meta: 'shacl property', score: 600 },
      { value: 'sh:minLength', meta: 'shacl property', score: 600 },
      { value: 'sh:maxLength', meta: 'shacl property', score: 600 },
      { value: 'sh:pattern', meta: 'shacl property', score: 600 },
      { value: 'sh:class', meta: 'shacl property', score: 600 },
      { value: 'sh:nodeKind', meta: 'shacl property', score: 600 },
      { value: 'sh:in', meta: 'shacl property', score: 600 },
      { value: 'sh:order', meta: 'shacl property', score: 600 },
      { value: 'sh:group', meta: 'shacl property', score: 600 },
      { value: 'sh:defaultValue', meta: 'shacl property', score: 600 },
      { value: 'sh:IRI', meta: 'shacl nodeKind', score: 500 },
      { value: 'sh:BlankNode', meta: 'shacl nodeKind', score: 500 },
      { value: 'sh:Literal', meta: 'shacl nodeKind', score: 500 },
      // RDF/RDFS
      { value: 'rdf:type', meta: 'rdf property', score: 500 },
      { value: 'rdfs:label', meta: 'rdfs property', score: 500 },
      { value: 'rdfs:comment', meta: 'rdfs property', score: 500 },
      { value: 'rdfs:subClassOf', meta: 'rdfs property', score: 500 },
      { value: 'rdfs:subPropertyOf', meta: 'rdfs property', score: 500 },
      { value: 'rdfs:domain', meta: 'rdfs property', score: 500 },
      { value: 'rdfs:range', meta: 'rdfs property', score: 500 },
      // XSD datatypes
      { value: 'xsd:string', meta: 'datatype', score: 400 },
      { value: 'xsd:integer', meta: 'datatype', score: 400 },
      { value: 'xsd:decimal', meta: 'datatype', score: 400 },
      { value: 'xsd:boolean', meta: 'datatype', score: 400 },
      { value: 'xsd:date', meta: 'datatype', score: 400 },
      { value: 'xsd:dateTime', meta: 'datatype', score: 400 },
      { value: 'xsd:float', meta: 'datatype', score: 400 },
      { value: 'xsd:double', meta: 'datatype', score: 400 },
      { value: 'xsd:anyURI', meta: 'datatype', score: 400 },
    ]

    const completions = keywords
      .filter(k => k.value.toLowerCase().includes(prefix.toLowerCase()))
      .map(k => ({
        caption: k.value,
        value: k.value,
        meta: k.meta,
        score: k.score
      }))

    callback(null, completions)
  }
} as const

// Register the completer
const langTools = ace.require('ace/ext/language_tools')
if (langTools) {
  langTools.addCompleter(turtleCompleter)
}
